type FeatureName = string;
type IsAllowedByFeatureName = (featureName: FeatureName) => boolean;

const isEnabled = (input: string | null): boolean => {
  // false チェックは前段の isDisallowedByFeatureName で実行済みのため、こちらは null チェックのみ
  return input !== null;
};

export const isAllowedByFeatureName: IsAllowedByFeatureName = (featureName) => {
  const queryParameters = new URLSearchParams(window.location.search);

  if (isEnabled(queryParameters.get(featureName))) return true;

  return isEnabled(localStorage.getItem(featureName));
};
